import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/apiClient";

export default function AdminLogin() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { await login(email, password); }
    catch (err) { setError(formatApiError(err.response?.data?.detail) || "Login failed"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F9FA] px-5">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="font-serif-display text-2xl font-bold text-[#111827]">IMPACTFUL <span className="text-[#0F2C59]">MINDSET</span></div>
          <p className="text-sm text-slate-500 mt-2">Content Management</p>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="bg-white border border-slate-200 p-8 space-y-4">
          <div>
            <label className="block text-xs font-semibold text-slate-600 mb-1">Email</label>
            <input data-testid="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-slate-300 px-4 py-3 focus:outline-none focus:border-[#0F2C59]" />
          </div>
          <div>
            <label className="block text-xs font-semibold text-slate-600 mb-1">Password</label>
            <input data-testid="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-slate-300 px-4 py-3 focus:outline-none focus:border-[#0F2C59]" />
          </div>
          {error && <p data-testid="admin-login-error" className="text-sm text-red-500">{error}</p>}
          <button data-testid="admin-login-submit" type="submit" disabled={loading}
            className="w-full bg-[#0F2C59] text-white py-3 text-sm font-semibold hover:bg-[#174082] disabled:opacity-50">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
